import { shimmer, toBase64 } from "@src/utils/shimmer";
import Image from "next/image";
import React from "react";
import flower from "../../../../public/images/pinkFlowerImage.png";
import { EventBySlugQuery } from "@src/@types/api.d";
import Icon from "@src/components/Icon";

interface IFooter {
  slug: EventBySlugQuery | undefined;
}

const Footer = ({ slug }: IFooter) => {
  return (
    <footer className="h-[4rem] w-full overflow-hidden bg-[#fff] flex flex-col justify-center items-center">
      <p className="font-ntFab text-[0.8rem] md:text-[1rem] leading-[100%] font-normal tracking-[0.2rem] text-[#454545]">
        MADE WITH{" "}
        <a
          href="https://www.inawo.com"
          target="_blank"
          rel="noopener noreferrer"
          className="border-b-[0.5px] border-[#725A3F] pb-[0.5px]"
        >
          INAWO
        </a>
      </p>
    </footer>
  );
};

export default Footer;
